
import { Image, Article, Section, DocsIntro, DocsHeader, SectionHeader, DocsHeading } from './extra/Components';
import { Content } from "./extra/Components";

import { Intro, introQuiz, introHeader, sff, klubbenSection, riskSection, introKrav, introAff, introKostnad, introQuizSection } from "./sections/Intro";

import {
    Material, materialQuiz, materialRigg, materialSkarm,
    materialKring,
    materialTrering,
    materialReserv,
    materialAAD,
    materialRSL,
    materialBrostrem,
    materialBromsar,
    materialElevriggar,
    materialPackcert,
    materialSelfcheck,
    materialQuizSection,
} from "./sections/Material";

import {
    Faltet, faltetFlygplanet, faltetHangar, faltetHeader, faltetIlastning, faltetKlubbstuga, faltetNodhopp, faltetQuizSection,
    faltetBanor,
    faltetLandningsomraden,
    faltetVindriktning,
    faltetHl,
    faltetHlT,
} from './sections/Faltet';

import {
    Hoppet, frifalletsPri, hoppetAff1, hoppetDrag, hoppetHojd, hoppetTecken, hoppetUthopp,
    hoppetSpotting,
    hoppetHeading,
    hoppetMoln,
    hoppetQuizSection
} from './sections/Hoppet';

import {
    UnderSkarm, skarmQuiz, underSkarmHurFlyger, underSkarmTaSigHem, underSkarmTurbulens, underSkarmLekområde, underSkarmMoln, underSkarmKommunikation, underSkarmQuizSection,
    underSkarmKallotdrill
} from './sections/Underskarm';

import {
    Felfunktioner, felfunkBeslutshojd, felfunkBraFallskärm, felfunkHogfarLagfart, felfunkIntro, felfunkKniv, felfunkKända, felfunkOrsaker, felfunkReservdrag, felfunkSelprov,
    felfunkQuizSection
} from './sections/Felfunkioner';

import { Landning, landningBargning, landningFlar, landningIntro, landningQuizSection, landningRiktning, landningRullning, landningUte, LandningVarv } from './sections/Landning';

import { Packning, packingKontroller, packningIntro, packningManualer } from './sections/Packning';

import {
    Aff, AffLevel, affLevels,
    affMoment, affQuizSection
} from './sections/Aff';

import { StorQuiz, storQuizSection } from './sections/Storquiz';

import ALicens from './sections/Alicens';

import Vidare from './sections/Vidare';

import {
    faListCheck,
    faTools,
    faMapSigns,
    faHandPointLeft,
    faPersonThroughWindow,
    faSkullCrossbones,
    faPersonFalling,
    faParachuteBox,
    faPlaneArrival,
    faKitMedical,
    faBoxesPacking,
    faInfo,
    faDiceOne,
    faDiceTwo,
    faDiceThree,
    faDiceFour,
    faDiceFive,
    faDiceSix,
    faTrophy,
    faTriangleExclamation,
    faLayerGroup,
    faUserGroup,
    faFolderOpen,
} from '@fortawesome/free-solid-svg-icons';

//import affExit from './assets/1 intro/4 klubben-small.jpg';
import affExit from './assets/4 hoppet/10 aff exit-small.jpg';
import aff1 from './assets/4 hoppet/11 aff 1 i firfall-small.jpg';
import flygaSkarm from './assets/5 fallskarm/8 flyga fallskärm-small.jpg'

import ova from './assets/10 drillande/2 öva-small.jpg'

import packande from './assets/8 packning/2 packaJobbigt-small.jpg';

import monkey from './assets/6 felfunk/felfunks/12 monkey fist-small.jpg';
import { Link } from 'react-router-dom';



const SydKort = ({ section, setSection, article, setArticle, club, setClub, targets }) =>
(<Content section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub}>
    {/** {TodoKort(targets)} **/}
    <Article id="introduktionkort" icon={faMapSigns} name="Intro" setArticle={setArticle} setSection={setSection} >
        {introHeader}
        <Section id="klubbIntro" name="Fallskärmsklubben Syd" skipBorder={true}>
            {klubbenSection}
            {sff}
        </Section>

        <Section id="eslövsflygfällt" name="Eslövs flygfällt" skipBorder={true}>
            {faltetHeader}
            {/** faltetBanor **/}
            {faltetHangar}
            {faltetKlubbstuga}
        </Section>
        {riskSection}

    </Article>
    <Article id="utrustningkort" icon={faTools} name="Utrustning" setArticle={setArticle} setSection={setSection} >
        <DocsIntro></DocsIntro>
        {/** <Section id="delarrigg" name="Delar rigg"></Section> 
                        <Section id="delarskärm" name="Delar skärm"></Section> */}
        {materialRigg}
        {materialSkarm}
    </Article>
    <Article id="drakort" icon={faHandPointLeft} name="Dra fallskärmen" setArticle={setArticle} setSection={setSection} >
        <DocsHeader>
            <DocsHeading note="">Drag av fallskärm</DocsHeading>
            <DocsIntro>
                <p>Frifallet är den centrala delen i fallskärmshoppning. Den har tre stycken huvudregler:</p>
                {frifalletsPri}
            </DocsIntro>
        </DocsHeader>
        {hoppetDrag}
        {hoppetHojd}
    </Article>
    <Article id="felfunktionerkort" icon={faSkullCrossbones} name="Felfunktioner" setArticle={setArticle} setSection={setSection} >

        {felfunkIntro}
        {felfunkBraFallskärm}
        {felfunkHogfarLagfart}

        {felfunkReservdrag}
        {felfunkBeslutshojd}
    </Article>
    <Article id="exitkort" icon={faPersonThroughWindow} name="Exit" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeader>
                <DocsHeading>Exit, ta sig ur flygplanet</DocsHeading>
                <Image image={affExit} />
                <p>
                    Att hoppa ut tre personer samtidigt och stabilt ur ett flygplan kräver synkronisering och kommunikation.
                </p>
            </DocsHeader>
        </DocsIntro>
        {hoppetUthopp}
        {faltetFlygplanet}
        <Section id="nödhopp" name="Nödhopp">
            {faltetNodhopp}
        </Section>
    </Article>
    <Article id="firstJumpkort" icon={faPersonFalling} name="Första hoppet" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeader>
                <DocsHeading>Första hoppet</DocsHeading>
                <Image image={aff1} />
                <p>Målet i det första hoppet är att kunna bryta genom chocken från att hoppa ur ett flygplan för
                    första gången och klara av att läsa sin höjdmätare.</p>
            </DocsHeader>
        </DocsIntro>
        {hoppetAff1}
        {hoppetTecken}
    </Article>
    <Article id="flyParachutekort2" icon={faParachuteBox} name="Flyga fallskärm" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeader>
                <DocsHeading>Flyga fallskärm</DocsHeading>
                <Image image={flygaSkarm} />
                <p>Fallskärmen flyger framåt om opåverkad. Den svänger höger om man drar i höger styrhandtag och vänster
                    om man drar i vänster. Drar man båda samtidigt bromsar den in.
                    Till synes enkelt men det krävs ändå en del erfarenhet att landa där man vill.
                </p>
            </DocsHeader>
        </DocsIntro>
        {underSkarmHurFlyger}
        {LandningVarv}
        {underSkarmKommunikation}
        <Section id="landaflyga" name="Landning">
            {landningIntro}
        </Section>
        {underSkarmTurbulens}
        <Section id="flygaÖvning" name="Övning">
            <p>Du kan testa var fallskärmen flyger och hur den påverkas av vinden med detta simuleringsverktyg</p>
            <Link to="/canopy">Flyg skärm sida</Link>
        </Section>


    </Article>
    <Article id="landingkort" icon={faPlaneArrival} name="Landa" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {landningFlar}
        </DocsIntro>
        {landningRullning}
        {landningUte}
    </Article>
    <Article id="reservdragkort" icon={faKitMedical} name="Öva" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeading>Övning ger färdighet</DocsHeading>
            <Image image={ova} />
            <p>
                Så mycket som möjligt vill vi bygga muskelminne på marken för saker vi ska göra i luften.
                Momenten i den här manualen bör repeteras många gånger tillsammans med instruktör.
            </p>
        </DocsIntro>
        {felfunkSelprov}
    </Article>
    <Article id="packingkort" icon={faBoxesPacking} name="Packning" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeading>Packning</DocsHeading>

            {packningIntro}
        </DocsIntro>

        {packningManualer}
        {packingKontroller}
        <Section id="praktisk repetition" name="Praktisk repetition">
            <SectionHeader>Öva packande</SectionHeader>
            <Image image={packande} />
            <p>
                Under kursen kommer du få se och testa att packa en fallskärm. Det tar några gånger innan man klurar ut det.
            </p>
        </Section>
    </Article>
    <Article id="felfunkisarMerkort" icon={faTriangleExclamation} name="Felfunktioner" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeading>Mer om felfunktioner</DocsHeading>
            <Image image={monkey} />
            <br />
            <p>
                Än är inte den sista felfunktionen upptäckt men här hittar du exempel på vad för saker man kan stöta på under en fallskärmskarriär.
            </p>
        </DocsIntro>
        {felfunkKända}
        {felfunkOrsaker}
        {felfunkKniv}
    </Article>
    <Article id="aff1" icon={faDiceOne} name="Aff hopp 1" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[0]}
        </DocsIntro>
        <Section id="program1" name="Teoriutbildning" skipBorder={true}>
            <h1>Teori innan det är dags för hopp 2</h1>
        </Section>
        {/** <Section id="mer utrustning" name="Utrustning">
                            <div>
                                <div>Utrustningen</div>
                                <div>-- Delarnas namn och funktion</div>
                                <div>-- Utrustningens nödsystemen (RSL/ADD/MARD)</div>
                                <div>-- Rservsdragsproceduren</div>
                                <div>-- Kännetecken för fungerande fallskärm</div>
                                <div>-- Felfunktioner + lösningar</div>
                                <div>-- Driftstörningar + lösningar</div>
                            </div>
                        </Section>
                        **/}
        {materialKring}
        {materialTrering}
        {materialReserv}
        {materialAAD}
        {materialRSL}
        {materialBrostrem}
        {materialBromsar}
        {materialElevriggar}
        {materialPackcert}
        {materialSelfcheck}
        {materialQuizSection}
    </Article>
    <Article id="aff2" icon={faDiceTwo} name="Aff hopp 2" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[1]}
        </DocsIntro>
        <Section id="program2" name="Teoriutbildning" skipBorder={true}>
            <h1>Teori innan det är dags för hopp 3</h1>
        </Section>

        <Section id="ilastning" name="Ilastning">
            {faltetIlastning}

        </Section>
        {/** <Section id="iochrunt2" name="I och runt flygplanet">
                            <div>
                                <div>I och runt flygplaner</div>
                                <div>-- Ilastning (bältet, kom påklädd)</div>
                                <div>-- Flyga upp/åka ner</div>
                                <div>-- Nödhopp</div>
                            </div>
                        </Section> **/}
        {faltetQuizSection}
    </Article>
    <Article id="aff3" icon={faDiceThree} name="Aff hopp 3" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[2]}
        </DocsIntro>
        <Section id="program3" name="Teoriutbildning" skipBorder={true}>
            <h1>Teori innan det är dags för hopp 4</h1>
        </Section>
        <Section id="Frifallf" name="I och runt flygplanet">
            <div>
                <div>Frifall</div>
                <div>-- Fartvinden vid uthopp</div>
                <div>-- Frifallstekniker (sväng, delta, hiss, broms)</div>
            </div>
        </Section>


    </Article>
    <Article id="aff4" icon={faDiceFour} name="Aff hopp 4" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[3]}
        </DocsIntro>
        <Section id="program4" name="Teoriutbildning" skipBorder={true}>
            <h1>Teori innan det är dags för hopp 5</h1>
        </Section>
        {/**<Section id="fallskärm" name="Fallskärm">
                            <div>
                                <div>Fallskärm</div>
                                <div>-- Lyftkraft, egendrivning</div>
                                <div>-- Skapa glidtal (ta sig hem)</div>
                                <div>-- Olika sätt att styra skärmen</div>
                                <div>-- Trafikregler</div>
                                <div>-- Landningsvarv (väntser och höger)</div>
                            </div>
                        </Section>
                        **/}
        {/**underSkarmKallotdrill */}
        {underSkarmTaSigHem}
        {underSkarmLekområde}
        {underSkarmMoln}
        {underSkarmQuizSection}
    </Article>
    <Article id="aff5" icon={faDiceFive} name="Aff hopp 5" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[4]}
        </DocsIntro>

        <Section id="program5" name="Teoriutbildning" skipBorder={true}>
            <h1>Teori innan det är dags för hopp 6</h1>
        </Section>

        <Section id="TurbulensochUte" name="Turbulens och utelandningar">
            <div>
                <div>Turbulens och utllandingar</div>
                <div>-- Vad är turbulens? Var finns det?</div>
                <div>-- Vad är termik? Var finns det?</div>
                <div>-- Vad är dåliga landningsplatser? Varför?</div>
                <div>-- Välja bra alternativ för utelandning.</div>
            </div>
        </Section>
    </Article>
    <Article id="aff6" icon={faDiceSix} name="Aff hopp 6" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[5]}
        </DocsIntro>
        <Section id="program6" name="Teoriutbildning" skipBorder={true}>
            <h1>Teori innan det är dags för hopp 7</h1>
        </Section>
        {/**<Section id="landa" name="Mer om landning">
                            <div>
                                <div>Landa</div>
                                <div>-- Landningsvarv (planera)</div>
                                <div>-- Landa mot vinden</div>
                                <div>-- Landa sidvind (ingen fara - lokala regler)</div>
                                <div>-- Rullning (hur och varför)</div>
                            </div>
                        </Section>**/}
        {landningRiktning}
        {landningBargning}
        {landningQuizSection}
    </Article>
    <Article id="aff7" icon={faTrophy} name="Aff hopp 7" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            {affLevels[6]}
        </DocsIntro>
        {storQuizSection}
    </Article>
    <Article id="affvidare" icon={faLayerGroup} name="Aff 8-20" setArticle={setArticle} setSection={setSection} >
        <DocsIntro>
            <DocsHeading>Ensamhoppen</DocsHeading>
            Affhopp 8 till 20 genomförs ensam. Man kollas av utav en instruktör i flygplanet och sen hoppar man.
        </DocsIntro>

        <Section id="Program10" name="Program" >
            <SectionHeader>Program</SectionHeader>
            <p>Eleven övar på valfri moment i samråd med sin instruktör. Draghöjd 1200m.</p>
            <p>Ett utav hoppen ska vara ett låghopp. Se nedan.</p>
        </Section>
        <Section id="Program låghopp" name="Aff låghopp" >
            {affLevels[9]}
        </Section>
    </Article>
    <Article id="hm-hopp" icon={faUserGroup} name="Aff 21-25 grupphoppning" setArticle={setArticle} setSection={setSection}>
        <DocsIntro>
            <DocsHeading>Hoppa med andra</DocsHeading>
            <p>Ibland kan dessa hopp kallas för hm-hopp då det förr fanns en liknande progression.</p>
            <p>Syftet med hopp 21-24 är att öva på hur man flyger med andra hoppare i luften på ett säkert sätt.</p>
        </DocsIntro>
        <Section id="aff21" name="Aff 21, framåtåkning" >
            <AffLevel
                name="AFF 21 - Framåtåkning och dockning"
                program={[
                    "Instruktör ger klartecken",
                    "Elev ger “key” och hoppar av",
                    "Instruktör backar 2 m på level",
                    "Elev flyger fram och dockar",
                    "Upprepa till 1500 m",

                    "Eleven vänger 180 och trackar",
                    "Drag på 1200m"
                ]}
                underCanopy={[
                    "Efter eget tycke."
                ]}
                goals={[
                    "Grunder i formationshoppning"
                ]}
                criteria={[
                    "Dra sin egen fallskärm på rätt höjd.",
                    "Bra dockning",
                    "Bra bryt"
                ]}
            >
            </AffLevel>
        </Section>
        <Section id="aff22" name="Aff 22, level" >
            <AffLevel
                name="AFF 22 - Framåtåkning och dockning"
                program={[
                    "Instruktör ger klartecken",
                    "Elev ger “key” och hoppar av",
                    "Instruktör backar 5 m till ny level",
                    "Elev flyger efter och dockar",
                    "Upprepa till 1500 m",

                    "Eleven vänger 180 och trackar",
                    "Drag på 1200m"
                ]}
                underCanopy={[
                    "Efter eget tycke."
                ]}
                goals={[
                    "Anpassa fallhastighet efter andra."
                ]}
                criteria={[
                    "Dra sin egen fallskärm på rätt höjd.",
                    "Kontroll över fallhastighet",
                    "Bra dockning",
                    "Bra bryt"
                ]}
            >
            </AffLevel>
        </Section>
        <Section id="aff23" name="Aff 23, Sväng och docka" >
            <AffLevel
                name="AFF 23 - Sväng och dockning"
                program={[
                    "Instruktör ger klartecken",
                    "Elev ger “key” och hoppar av",
                    "Instruktör gör en 360 sväng och backar",
                    "Elev gör en 360 sväng och flyger fram och dockar",
                    "Upprepa till 1500 m",

                    "Eleven vänger 180 och trackar",
                    "Drag på 1200m"
                ]}
                underCanopy={[
                    "Efter eget tycke."
                ]}
                goals={[
                    "Anpassa fallhastighet efter andra.",
                    "Hoppa i formation",
                    "360 svängar i båda riktningar",
                ]}
                criteria={[
                    "Dra sin egen fallskärm på rätt höjd.",
                    "Bra dockning",
                    "Bra bryt",
                    "Kontrollerad rotation"
                ]}
            >
            </AffLevel>
        </Section>
        <Section id="aff24" name="Aff 24, Dyka mot annan hoppare" >
            <AffLevel
                name="AFF 24 - Framåtåkning och dockning"
                program={[
                    "Elev ger klartecken",
                    "Instruktör ger “key” och hoppar av ogreppat i float exit",
                    "Eleven dyker efter instruktören",
                    "Elev tar level, flyger fram och dockar",
                    "Upprepa till 1500 m",
                    "Eleven vänger 180 och trackar",
                    "Drag på 1200m"
                ]}
                underCanopy={[
                    "Efter eget tycke."
                ]}
                goals={[
                    "Komma ikapp en annan hoppare"
                ]}
                criteria={[
                    "Dra sin egen fallskärm på rätt höjd.",
                    "Kontrollerad dockning på level.",
                    "Bra bryt"
                ]}
            >
            </AffLevel>
        </Section>

        <Section id="aff25" name="Aff 25, Nödhopp" >
            <AffLevel
                name="AFF 25 - Simulerat nödhopp"
                program={[
                    "Uthopp på 1000m",
                    "Stabilt drag inom 6 sekunder. ",
                ]}
                underCanopy={[
                    "Efter eget tycke."
                ]}
                goals={[
                    "Vara stabil i exit för nödhopp"
                ]}
                criteria={[
                    "Stabilt uthopp med tydlig svank"
                ]}
            >
            </AffLevel>
        </Section>
    </Article>
    {ALicens(targets)}
    {Vidare(targets)}
    <Article id="oanvänt" icon={faFolderOpen} name="Oanvända sektioner" setArticle={setArticle} setSection={setSection}>
        <SectionHeader></SectionHeader>
        {introKrav}
        {introAff}
        {introKostnad}

        {introQuizSection}

        {faltetBanor}
        {faltetLandningsomraden}
        {faltetVindriktning}
        {faltetHl}
        {faltetHlT}

        {hoppetSpotting}
        {hoppetHeading}
        {hoppetMoln}
        {hoppetQuizSection}

        {underSkarmKallotdrill}

        {felfunkQuizSection}

        {affMoment}
        {affQuizSection}
    </Article>
    {TodoKort(targets)}
</Content>);




const TodoKort = ({ setSection, setArticle }) => (
    <Article name="Att göra listan från chatten" icon={faListCheck} id="attgora" setArticle={setArticle} setSection={setSection}>
        <DocsHeader >
            <h1 className="docs-heading">Kortkurs, Kursupplägg 8h <span className="docs-time">Last updated:
                2026-03-25</span>
            </h1>
            <DocsIntro>
            </DocsIntro>
        </DocsHeader >
        <Section id="Kursupplägg" name="Kursupplägg" >
            <p>
                Intro och  hälsa och säkerhet (45min)
            </p>
            <ul>
                <li>
                    Kort om oss, Kort om er
                </li>
                <li>
                    Kort om fältet vi är på
                </li>
            </ul>
        </Section>
        <Section id="Utrustning" name="Utrustning" >
            <p>
                Utrustning (90 min)
            </p>
            <ul>
                <li>
                    Ganska grundlig genomgång
                </li>
                <li>
                    Repetera! Postit-övning
                </li>
            </ul>
        </Section>
        <Section id=" Dra fallskärmen " name=" Dra fallskärmen " >
            <p>
                Dra fallskärmen (30 min)
            </p>
            <ul>
                <li>
                    Visa, träna drag
                </li>
                <li>
                    Prata draghöjd
                </li>
                <li>
                    Viktig färdighet att känna sig trygg med!
                </li>
                <li>
                    Träna kasta pilot i riktig elevrigg
                </li>
            </ul>
        </Section>
        <Section id="Felfunktioer" name="Felfunktioer" >
            <p>
                Felfunktioner (30 min)
            </p>
            <ul>
                <li>
                    Prata harddeck. 1000m. Sparka snodd. Två flär.
                </li>
                <li>
                    Is it there? Is it square? does it flare?
                </li>
                <li>
                    Prata om hög- låg och felfunkisar. filmer tar vi sen. Vad tittar man efter?
                </li>
            </ul>
        </Section>
        <Section id="Exit" name="Exit" >
            <p>
                Exit (30 min)
            </p>
            <ul>
                <li>
                    Prata exit
                </li>
                <li>
                    Prata om i och runt flygplanet
                </li>
                <li>
                    Prata nödhopp
                </li>
            </ul>
        </Section>
        <Section id="Första hoppet" name="Första hoppet" >
            <p>
                Första hoppet (45 min)
            </p>
        </Section>
        <Section id="Flyga fallskärm" name="Flyga fallskärm" >
            <p>
                Flyga fallskärm (30 min)
            </p>
            <ul>
                <li>

                    Prata trafikvarv
                </li>
                <li>
                    Prata väjningsplikt
                </li>
                <li>
                    Prata styr- och bromsdon
                </li>
                <li>
                    Prata om att landa sin fallskärm
                </li>
                <li>
                    Turbulent och termik
                </li>
            </ul>
        </Section>
        <Section id="Landa" name="Landa" >
            <p>
                Landa (30 min)
            </p>
            <ul>
                <li>
                    Rulla
                </li>
                <li>
                    Landa utanför hoppfältet
                </li>
            </ul>
        </Section>
        <Section id="Reservdrag" name="Reservdrag" >
            <p>
                Reservdrag/sele (30 min)
            </p>
            <ul>
                <li>
                    Visa och träna drag
                </li>
                <li>
                    Dummy!
                </li>
                <li>
                    sparka snodd. rimligt scenario första hoppen.
                </li>
                <li>
                    Viktig färdighet att känna sig trygg med.
                </li>
            </ul>
        </Section>
        <Section id="Packing" name="Packing" >
            <p>
                Packing (rep. utrustning) (30 min)
            </p>
            <ul>
                <li>
                    Visa packning
                </li>
                <li>
                    Passa på att repetera utrustningens delar
                </li>
            </ul>
        </Section>
        <Section id="filmer" name="filmer" >
            <p>
                Gemensamma filmer av felfunktioner och sånt (90 min)
            </p>
            <ul>
                <li>
                    Filmer
                </li>
                <li>
                    Kaffe
                </li>
                <li>
                    Diskussioner
                </li>
            </ul>
        </Section>
    </Article >);

export { SydKort };